export function isAbsoluteUrl(url) {
  return url.startsWith('http');
}
